import { ENDPOINTS } from "./endpoints";
import { ImportacionMasivaResponseI } from "dtos/pci";
import { FetchCallbackI } from "./request/request.interface";
import { sendRequest } from "./request/request.service";
import { servicesUtils } from "./utils/services.utils";

// TODO: Este servicio es temporal, eventualmente los datos de instituciones vendrán de una API externa
export const getInstituciones = async (params?: any) => {
  const response = await sendRequest<any>({
    method: "GET",
    uri: ENDPOINTS.INSTITUCION + "/all",
    params,
  });
  return response;
};

export const postImportacionMasivaInstitucion = async ({
  params,
  images,
}: FetchCallbackI) => {
  const response = await sendRequest<ImportacionMasivaResponseI>({
    method: "POST",
    uri: ENDPOINTS.INSTITUCION + "/import",
    images: images,
    params: servicesUtils.removeNullNonEmptyParamsInFilters(params),
  });

  return response;
};
